import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import { withTheme } from '@material-ui/core/styles';
import connect from '../../core/EcrionProvider/connect';
import DefaultNavBar from './variants/default';
import MicroserviceNavBar from './variants/microservice';
import { usePageNavBar } from '../Provider';
/**
 * @param {import('./types').PageNavBarProps & import('@material-ui/core').WithTheme} props
 */

var NavBar = function NavBar(_ref) {
  var theme = _ref.theme,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ["theme", "children"]);

  usePageNavBar();
  var defaultProps = theme.getProps('Page.NavBar');

  var props = _objectSpread({}, defaultProps, restProps);

  var variant = props.variant,
      rest = _objectWithoutProperties(props, ["variant"]);

  if (!variant || variant === 'default') children = React.createElement(DefaultNavBar, rest);else if (variant === 'microservice') children = React.createElement(MicroserviceNavBar, rest);else if (variant === 'custom-children') {// do nothing
  } else throw new Error('Unknown variant');
  return React.createElement(AppBar, {
    position: "static",
    elevation: 0
  }, children);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    userInfo: state.userInfo,
    manifest: state.manifest
  };
};

NavBar.defaultProps = {
  logoProps: {}
};
export default withTheme(connect(mapStateToProps)(NavBar));